var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Flag2 = function Flag2(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 .707 1.707L15.914 9.5l3.793 3.793A1 1 0 0 1 19 15H6v6a1 1 0 1 1-2 0V5Zm2 8h10.586l-2.793-2.793a1 1 0 0 1 0-1.414L16.586 6H6v7Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Flag2;